import { useNicheError } from './niche-error.model'
import type { INicheError } from './niche-error.types'
import { NicheErrorView } from './niche-error.view'

export function NicheError({ onRetry }: INicheError) {
  const nicheErrorModel = useNicheError({ onRetry })
  return <NicheErrorView {...nicheErrorModel} />
}
